export default {
  addDiversity: ({ commit }, payload) => commit("ADD_DIVERSITY", payload),
}